var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0263 0H6.01468V2.99643C6.01468 4.66112 4.6596 5.99287 3.01923 5.99287H0V18.0024C0 19.1201 0.903391 20 1.99697 20H14.0026C15.1199 20 15.9995 19.0963 15.9995 18.0024V1.99762C16.0233 0.903686 15.1437 0 14.0263 0ZM12.0294 15.0297H4.01771C3.47092 15.0297 3.01923 14.5779 3.01923 14.0309C3.01923 13.4839 3.47092 13.0321 4.01771 13.0321H12.0294C12.5762 13.0321 13.0278 13.4839 13.0278 14.0309C13.0278 14.5779 12.5762 15.0297 12.0294 15.0297ZM12.0294 11.0345H4.01771C3.47092 11.0345 3.01923 10.5826 3.01923 10.0357C3.01923 9.4887 3.47092 9.03686 4.01771 9.03686H12.0294C12.5762 9.03686 13.0278 9.4887 13.0278 10.0357C13.0278 10.5826 12.5762 11.0345 12.0294 11.0345Z",
    fill: "#141938"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01771 3.02021V0L0 4.01902H2.99545C3.56602 4.01902 4.01771 3.56718 4.01771 3.02021Z",
    fill: "#141938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocument);
export default __webpack_public_path__ + "static/media/ic_document.ac5864fd8d390b1c0e73c15c927735f3.svg";
export { ForwardRef as ReactComponent };